import { Cascader } from 'element-ui'

const YCascader = Cascader
YCascader.$depends = [Cascader]
YCascader.$name = 'y-cascader'
YCascader._name = 'Cascader 级联选择器'

export default YCascader
